import { getConfigForImportedTest } from 'Components/Worksheets/Config';
import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import qestIds from '../../../QestIds';
import getLabelConfig from './labelConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      ...getConfigForImportedTest(
        qestIds.moistureContent.AS_1289_2_1_1.rev2005,
        'data.Preparation.AssociatedFieldMoistureContent'
      ),
      [`${prefix}.Preparation.ReducedLevelToLayer`]: { uom: 'm', format: { nearest: 0.01 } },
      [`${prefix}.Preparation.MeasurementAtZeroBlows`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Preparation.SurfaceLevelToLayer`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Preparation.GroundWaterTableDepth`]: { uom: 'm', format: { nearest: 0.1 } },
      [`${prefix}.Preparation.GraduationInterval`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Preparation.AssociatedFieldMoistureContent.ExternalTest.Results.MoistureContentPercent`]: {
        format: { nearest: 0.1 },
      },

      [`${prefix}.Measurements.Measurements.PenetrationReading`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Measurements.Measurements.Penetration`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Measurements.Measurements.Depth`]: { uom: 'mm', format: { nearest: 1 } },

      [`${prefix}.Results.StartDepth`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Results.FinalDepth`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Results.PenetrationResistance`]: { uom: 'Blows/300mm', format: { nearest: 0.1 } },
      [`${prefix}.Results.BlowsPerGraduationInterval`]: { format: { nearest: 0.1 } },
      [`${prefix}.Results.DepthToMidpoint`]: { uom: 'mm', format: { nearest: 1 } },
    },
    getLabelConfig(prefix)
  );

export default {
  [qestIds.dynamicConePenetrometer.AS_1289_6_3_2.rev1997]: getConfig,
};
